//
//
//

import G2 from '@antv/g2';

export default {
  name: 'piechart',
  props: ['chartData', 'chartId'],
  data() {
    return {
      data: [],
      id: '',
      piechart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      // console.log(newVal)
      this.piechart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    // console.log(this.id);
    // console.log(this.data);
    let that = this;
    this.piechart = new G2.Chart({
      container: that.id,
      forceFit: true,
      height: document.querySelector('#' + that.id + '').clientHeight,
      width: document.querySelector('#' + that.id + '').clientWidth,
      // padding: [20, 40, 42, 100]
      padding: 'auto'
    });
    this.piechart.source(that.data, {
      percent: {
        formatter: function formatter(val) {
          val = val * 100 + '%';
          return val;
        }
      }
    });
    this.piechart.coord('theta', {
      radius: 0.75
    });
    this.piechart.tooltip({
      showTitle: false,
      itemTpl:
        '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>'
    });
    var interval = this.piechart
      .intervalStack()
      .position('percent')
      .color('item')
      .label('percent', {
        formatter: function formatter(val, item) {
          return item.point.item + ': ' + val;
        }
      })
      .tooltip(false);
    this.piechart.render();
    interval.select(false);
  }
};
